import { useEffect, useState } from "react";
import "./App.css";
import "./global/table.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { Login } from "./view/Login";
import { ResetPass } from "./view/ResetPass";
import { Home } from "./view/Home";
import { Dashboard } from "./view/Dashboard";
import { ProtectedRoute } from "./components/ProtectedRoutes";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "./reducers/authSlice";
import Cookies from "js-cookie";
import ProductList from "./view/ProductList";
import Orders from "./view/Orders";
import Enquiries from "./view/Enquiries";
import CustomerList from "./view/CustomerList";
import Header from "./components/Header";
import UserProfile from "./view/UserProfile";
import { SlideBar } from "./components/SlideBar";
import PaymentHistory from "./view/PaymentHistory";
import Campaigns from "./view/Campaigns";
import parseJwt from "./utils/authUtils";
import { subscription } from "./reducers/authSlice";
import { Companies } from "./view/Companies";
import { Company } from "./view/Company";
import Notifications from "./view/Notifications";

function App() {
  const [currentPath, setCurrentPath] = useState();
  const { isLogedIn } = useSelector((state) => state.authenticate);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    setCurrentPath(currentPath);
    //const token = Cookies.get("token");
    const token = localStorage.getItem("token");

    if (token) {
      const user = parseJwt(token);
      dispatch(setUser(user));
      // dispatch(subscription(user.companyId))
      navigate(currentPath);
    }
  }, []);

  return (
    <div className="App">
      {isLogedIn ? (
        <header className="header__app">
          <Header currentPath={currentPath} />
        </header>
      ) : (
        <></>
      )}
      <main>
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/dashboard/:transactionid"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/campaigns"
            element={
              <ProtectedRoute>
                <Campaigns />
              </ProtectedRoute>
            }
          />
          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <ProductList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <Orders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/enquries"
            element={
              <ProtectedRoute>
                <Enquiries />
              </ProtectedRoute>
            }
          />
          <Route
            path="/categories"
            element={
              <ProtectedRoute>
                <CategoryList />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/notifications"
            element={
              <ProtectedRoute>
                <Notifications />
              </ProtectedRoute>
            }
          />
          <Route
            path="/customers"
            element={
              <ProtectedRoute>
                <CustomerList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/companies"
            element={
              <ProtectedRoute>
                <Companies />
              </ProtectedRoute>
            }
          />

          <Route
            path="/company/:companyId"
            element={
              <ProtectedRoute>
                <Company />
              </ProtectedRoute>
            }
          />

          <Route
            path="/userprofile"
            element={
              <ProtectedRoute>
                <UserProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/paymenthistory"
            element={
              <ProtectedRoute>
                <PaymentHistory />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route path="/resetpass" element={<ResetPass />} />
          <Route path="*" element={<p>There's nothing here </p>} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
